export default __webpack_public_path__ + "static/media/course_4.bdf43ddd.png";